module.exports = {
  add: (app) => {
    app.ports.localhostConnectRequest.subscribe(({ connectUrl }) => {
      fetch(connectUrl, { method: "POST" })
        .then((res) => {
          app.ports.localhostConnectResult.send(res.ok);
        })
        .catch((err) => {
          console.error("Localhost connect failed:", err);
          app.ports.localhostConnectResult.send(false);
        });
    });
  },
};
